import React, { useState, useEffect } from "react";
import "./index.scss";
import { Box, Grid, IconButton, Typography } from "@mui/material";
import FormGenerator from "../../../../core/form-generator";
import { getWsmFormConfig, HeaderConfig } from "./config";
import SiFileUpload from "../../../../core/file-uploader";
import {
  getFileNameFromUrl,
  handleFormValidation,
  splitFileName,
} from "../../../../utils";
import {
  HTTP_METHODS,
  invokeApi,
  plainApi,
} from "../../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../../utils/endpoints";
import { toast } from "react-toastify";
import SiAutocomplete from "../../../../core/si-autocomplete";
import CustomButtonComponent from "../../../../core/custom-button";
import CustomTable from "../../../../core/custom-table";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import DeleteModal from "../../../../components/delete-modal";
const CreateWsm = ({ loadData, wsmData, editData }) => {
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [file, setFiles] = useState("");
  const [oems, setOems] = useState([]);
  const [approverList, setApproverList] = useState([]);
  const [currentWorkshopManual, setCurrentWorkshopManual] = useState([]);
  const [isEditRevision, setIsEditRevision] = useState({
    isEdit: false,
    id: "",
  });
  const [isDelete, setIsDelete] = useState({ isOpen: false, data: {} });
  const [engineModelImg, setEngineModelImg] = useState("");
  const getApproverList = () => {
    invokeApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.APPROVER_LIST}`)
      .then((res) => {
        if (res.message) {
          toast.error("Approvers not found");
        } else {
          const result = res.map((ele) => ({ label: ele.name, value: ele.id }));
          setApproverList(result);
        }
      })
      .catch((err) => console.error(err));
  };
  const loadOems = (filters) => {
    invokeApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.OEM_NAMES}`, null, {
      ...filters,
    })
      .then((response) => {
        if (response) {
          const result = response.map((ele) => ({
            label: ele.name,
            value: ele.id,
          }));
          setOems(result);
        }
      })
      .catch((err) => console.error(err));
  };
  const callBack = (newFile) => {
    setFiles(newFile?.url);
  };
  const resetForm = () => {
    setFormData({});
    setCurrentWorkshopManual([]);
    setFiles("");
    setIsEditRevision({ isEdit: false, id: "" });
    loadData({
      page: 1,
      limit: 100,
      sortBy: "-createdAt",
      approvalStatus: "APPROVED",
    });
    setEngineModelImg("");
  };
  const submitHandler = () => {
    const isValid = handleFormValidation(
      getWsmFormConfig(oems),
      setErrors,
      formData
    );
    if (isValid) {
      const payload = {
        engineModel: formData?.engineModel,
        oem: formData?.oem?.value,
        versionNumber: formData?.versionNumber,
        remarks: formData?.remarks,
        approvedBy: formData?.approvedBy?.value,
        listNumber: formData?.listNumber,
        releasedOn: formData?.releasedOn,
      };
      if (file) {
        payload["document"] = file;
      }
      if (engineModelImg) {
        payload["image"] = engineModelImg;
      }
      invokeApi(
        HTTP_METHODS.POST,
        `${HOSTNAME}${REST_URLS.WORKSHOP_MANUAL}`,
        payload
      )
        .then((res) => {
          if (res.message) {
            toast.error(res.message);
          } else {
            toast.success("Created Successfully");
            resetForm();
          }
        })
        .catch((err) => console.error(err));
    }
  };
  const editRevisionHandler = () => {
    const id = isEditRevision?.id;
    const payload = {
      versionNumber: formData?.versionNumber,
      releasedOn: formData?.releasedOn,
      listNumber: formData?.listNumber,
      remarks: formData?.remarks,
      approvedBy: formData?.approvedBy?.value,
      engineModel: formData?.engineModel,
      oem: formData?.oem?.value,
    };
    if (file) {
      payload["document"] = file;
    }
    invokeApi(
      HTTP_METHODS.PUT,
      `${HOSTNAME}${REST_URLS.WORKSHOP_MANUAL}/${id}`,
      payload
    )
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          toast.success("Updated Successfully");
          resetForm();
        }
      })
      .catch((err) => console.error(err));
  };

  const editList = (data) => {
    setFormData({
      engineModel: data?.engineModel,
      oem: oems?.find((ele) => ele.value === data?.oem?.id),
      versionNumber: data?.versionNumber,
      releasedOn: data?.releasedOn,
      remarks: data?.remarks,
      listNumber: data?.listNumber,
    });
    if (data?.document) {
      setFiles(data?.document);
    }
    setIsEditRevision({ isEdit: true, id: data.id });
    setCurrentWorkshopManual([data]);
  };
  const deleteHandler = () => {
    const id = currentWorkshopManual[0]?.id;

    invokeApi(
      HTTP_METHODS.DELETE,
      `${HOSTNAME}${REST_URLS.WORKSHOP_MANUAL}/${id}`
    )
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          toast.success("Deleted Successfully");
        }
        setIsDelete({
          isOpen: false,
          data: {},
        });
        resetForm();
      })
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    loadData({
      page: 1,
      limit: 100,
      sortBy: "-createdAt",
      approvalStatus: "APPROVED",
    });
    getApproverList();
    loadOems();
  }, []);
  useEffect(() => {
    if (Object.keys(editData).length) {
      editList(editData);
      setIsEditRevision({ isEdit: true, id: editData.id });
    }
  }, [editData, oems]);
  // useEffect(() => {
  //   if (formData.engineModel) {
  //     const filteredData = wsmData?.results?.find(
  //       (ele) => ele?.engineModel === formData.engineModel
  //     );
  //     if (filteredData) {
  //       setCurrentWorkshopManual([filteredData]);
  //     } else {
  //       setCurrentWorkshopManual([]);
  //     }
  //   } else {
  //     if (currentWorkshopManual.length) {
  //       setCurrentWorkshopManual([]);
  //     }
  //   }
  // }, [formData.engineModel]);

  return (
    <div>
      <div
        className="form-con"
        style={{ width: "100%", maxHeight: "300px", overflow: "auto" }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <p className="primary-text p-margin-0">Workshop Manuals</p>
          <div>
            {isEditRevision?.isEdit && (
              <IconButton
                onClick={() =>
                  setIsDelete({ isOpen: true, data: currentWorkshopManual })
                }
              >
                <CustomButtonComponent variant="contained" color="error">
                  Delete {formData.engineModel} {formData.versionNumber}
                </CustomButtonComponent>
              </IconButton>
            )}

            <IconButton onClick={resetForm}>
              <AutorenewIcon color="primary" />
            </IconButton>
          </div>
        </Box>

        <Grid container sx={{ mt: 1, pl: 3 }} spacing={1}>
          {wsmData?.results?.length ? (
            wsmData.results.map((ele) => {
              return (
                <Grid item md={1.5}>
                  <div key={ele.id}>
                    <p className="wsm-list p-margin-0">
                      {ele?.engineModel} WSM
                    </p>
                    <ul>
                      <li onClick={() => editList(ele)} className="clickable">
                        <p className="wsm-list p-margin-0">
                          {ele?.engineModel} {ele?.versionNumber}
                        </p>
                      </li>
                    </ul>
                  </div>
                </Grid>
              );
            })
          ) : (
            <Typography variant="h5" sx={{ textAlign: "center" }}>
              No Data
            </Typography>
          )}
        </Grid>
      </div>
      <div className="form-con" style={{ width: "100%" }}>
        <FormGenerator
          config={getWsmFormConfig(oems)}
          formData={formData}
          setFormData={setFormData}
          errors={errors}
          setErrors={setErrors}
          fieldGridSize={4}
        />
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 2,
            mb: 2,
            gridGap: "30px",
          }}
        >
          {currentWorkshopManual.length < 1 && !engineModelImg && (
            <SiFileUpload
              fileTypes={["image/*"]}
              callBack={(newFile) => setEngineModelImg(newFile?.url)}
              id={null}
              title="Upload Engine model Image"
            />
          )}
          <div>
            <SiFileUpload id={null} callBack={callBack} />
          </div>
        </Box>
        {engineModelImg && (
          <Box
            sx={{
              border: "1px solid lightGray",
              width: "fit-content",
              borderRadius: "5px",
              overflow: "hidden",
            }}
          >
            <img src={engineModelImg} alt="engine-model" width="100px" />
          </Box>
        )}
        <br />
        {file && (
          <a
            href={splitFileName(file)}
            target="_blank"
            rel="noopener noreferrer"
          >
            {getFileNameFromUrl(file, 100)}
          </a>
        )}
      </div>
      <div className="form-con" style={{ width: "100%" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end",
            mr: 2,
            mb: 3,
          }}
        >
          <div>
            <p>Approver Name</p>
            <SiAutocomplete
              options={approverList}
              value={formData.approvedBy || ""}
              onChange={(value) =>
                setFormData((prevVal) => ({
                  ...prevVal,
                  approvedBy: value,
                }))
              }
              sx={{ width: "300px" }}
              placeholder="Select Approver"
            />
          </div>
          <CustomButtonComponent
            variant="contained"
            color="primary"
            sx={{ width: "200px" }}
            disabled={!formData.approvedBy}
            onClick={
              isEditRevision?.isEdit ? editRevisionHandler : submitHandler
            }
          >
            Submit for Approval
          </CustomButtonComponent>
        </Box>
      </div>
      {isDelete?.isOpen && (
        <DeleteModal
          deleteHandler={deleteHandler}
          onClose={() => {
            setIsDelete({ isOpen: false, data: {} });
          }}
        />
      )}
    </div>
  );
};

export default CreateWsm;
